module.exports = "<div kd-switch__thumb tabindex=\"0\"></div>\r\n";


//////////////////
// WEBPACK FOOTER
// ./src/kendu/ui/components/kd-switch/template.html
// module id = 319
// module chunks = 0